import React from "react";
import {NavLink, Route, Switch} from "react-router-dom"
import {rolePageMapping} from "./utils/roles";


const NavbarISO = (props) => {
    return (
        <div className="Navbar">
            <Switch>
                <Route>
                    <div className="tableWrapper">
                        <ul className="header">
                            {
                                rolePageMapping.account.includes(props.role)
                                &&
                                <li><NavLink to="/account">Account Details</NavLink></li>
                            }
                            {
                                rolePageMapping.swdownload.includes(props.role)
                                &&
                                <li><NavLink to="/sw-download">Downloads</NavLink></li>
                            }

                            {
                                rolePageMapping.admin.includes(props.role)
                                &&
                                <li><NavLink to="/operator">Administration</NavLink></li>
                            }
                        </ul>
                    </div>
                </Route>
            </Switch>
        </div>
    )

}

export default NavbarISO